// jsCustomMixForm
// jsCustomMixTab
import { checkEmail } from "./productTools";
interface BuyInOneClickReq {
	email: string;
	lang: string;
	productId: number;
	services?: any;
	comment?: string;
	phone?: string;
}
const customMix = {
	dom: <{ [key: string]: Element }>{},
	init: () => {
		customMix.dom.jsCustomMix = document.querySelector(`.jsCustomMix`)!;
		customMix.dom.jsCustomMixForm =
			document.querySelector<HTMLFormElement>(`.jsCustomMixForm`)!;
		customMix.dom.jsLoader = document.querySelector(`.jsTextLoader`)!;

		customMix.dom.jsCustomMixForm.addEventListener(
			"submit",
			(event: any) => {
				event.preventDefault();
				customMix.dom.jsLoader.classList.add("isOpen");
				customMix.createOrder();
			}
		);
		//
		customMix.dom.jsCustomMixTab1 =
			document.querySelectorAll(`.jsCustomMixTab`)[0]!;
		customMix.dom.jsCustomMixTab2 =
			document.querySelectorAll(`.jsCustomMixTab`)[1]!;
		customMix.dom.jsCustomMixTabInput1 =
			document.querySelectorAll(`.jsCustomMixTabInput`)[0]!;
		customMix.dom.jsCustomMixTabInput2 =
			document.querySelectorAll(`.jsCustomMixTabInput`)[1]!;

		customMix.dom.jsCustomMixTab1.addEventListener("click", (el) => {
			customMix.dom.jsCustomMix.classList.remove("ActiveTab2");
			customMix.dom.jsCustomMix.classList.add("ActiveTab1");
			// @ts-ignore
			customMix.dom.jsCustomMixTabInput1.checked = true;
			// @ts-ignore
			customMix.dom.jsCustomMixTabInput2.checked = false;
		});
		customMix.dom.jsCustomMixTab2.addEventListener("click", (el) => {
			customMix.dom.jsCustomMix.classList.remove("ActiveTab1");
			customMix.dom.jsCustomMix.classList.add("ActiveTab2");
			// @ts-ignore
			customMix.dom.jsCustomMixTabInput1.checked = false;
			// @ts-ignore
			customMix.dom.jsCustomMixTabInput2.checked = true;
		});
	},
	createOrder: async () => {
		// @ts-ignore
		const formData = new FormData(customMix.dom.jsCustomMixForm);
		const req: BuyInOneClickReq = {
			email: formData.get("email")?.toString() || "",
			comment: formData.get("comment")?.toString() || "",
			phone: formData.get("phone")?.toString() || "",
			// @ts-ignore
			lang: window.langLabel,
			productId: 5353,
		};
		if (!(await checkEmail(req.email))) return;
		fetch(`ajax-api/buy_in_one_click.php`, {
			method: "post",
			body: JSON.stringify(req),
		})
			.then((res) => res.json())
			.then(async (res) => {
				console.log("res customMix createOrder", res);
				if (res.order?.url) {
					// customMix.dom.jsCustomMixForm
					const url = `/order/${res.order.url}`;
					if (dropArea.state.files.length > 0) {
						customMix.uploadFiles(
							dropArea.state.files,
							res.order.id,
							url
						);
					} else {
						location.pathname = url;
					}
				} else {
					alert("error customMix createOrder");
					if (customMix.dom.jsLoader) {
						customMix.dom.jsLoader.classList.remove("isOpen");
					}
				}
			})
			.catch((error) => {
				alert(error);
				if (customMix.dom.jsLoader) {
					customMix.dom.jsLoader.classList.remove("isOpen");
				}
			});
	},
	uploadFiles: async (files: Array<any>, id: number, url: string) => {
		console.log("customMix uploadFiles", files);

		const formData = new FormData();
		files.forEach((file) => formData.append("files[]", file));
		formData.append("orderId", id + "");

		await fetch(`ajax-api/customMix.php`, {
			method: "post",
			body: formData,
		})
			.then((res) => res.json())
			.then((res) => {
				console.log("res customMix uploadFiles", res);
				if (res.success) {
					location.pathname = url;
				} else {
					alert("error customMix uploadFiles");
					if (customMix.dom.jsLoader) {
						customMix.dom.jsLoader.classList.remove("isOpen");
					}
				}
			})
			.catch((error) => {
				alert(error);
				if (customMix.dom.jsLoader) {
					customMix.dom.jsLoader.classList.remove("isOpen");
				}
			});
		//
	},
};
const dropArea = {
	dom: <{ [key: string]: Element }>{},
	state: {
		files: [],
	},
	render: () => {
		dropArea.dom.dropAreaEl.classList.add("isContainFiles");
		//
		if (dropArea.state.files.length > 0) {
			let list = ``;
			dropArea.state.files.forEach((file: any, index: number) => {
				list += `<li>${index + 1} - ${file.name}</li>`;
			});
			dropArea.dom.jsFilesRender.innerHTML = `<ul>${list}</ul>`;
		} else {
			dropArea.dom.dropAreaEl.classList.remove("isContainFiles");
		}
	},
	clearFiles: () => {
		dropArea.state.files = [];
		dropArea.render();
	},
	init: () => {
		// console.clear();
		console.log("dropArea init");

		dropArea.dom.dropAreaEl = document.getElementById("jsDropArea")!;
		dropArea.dom.jsfileElem = document.querySelector(".jsfileElem")!;
		dropArea.dom.jsFilesRender =
			dropArea.dom.dropAreaEl.querySelector(".jsFilesRender")!;
		dropArea.dom.jsFilesClear =
			dropArea.dom.dropAreaEl.querySelector(".jsFilesClear")!;
		dropArea.dom.jsFilesClear.addEventListener(
			"click",
			dropArea.clearFiles
		);
		console.log("customMix", dropArea.dom.dropAreaEl, dropArea);

		const preventDefaults = (e: any) => {
			e.preventDefault();
			e.stopPropagation();
		};

		const highlight = (e: any) => {
			dropArea.dom.dropAreaEl.classList.add("isHighlight");
		};

		const unhighlight = (e: any) => {
			dropArea.dom.dropAreaEl.classList.remove("isHighlight");
		};

		const handleDrop = (e: any) => {
			var dt = e.dataTransfer;
			var files = dt.files;
			handleFiles(dropArea.valid(files));
		};
		const handleFiles = (files: any) => {
			files = [...files];
			console.log("handleFiles files", files);
			// @ts-ignore
			dropArea.state.files = [...dropArea.state.files, ...files];
			dropArea.render();
		};

		// Prevent default drag behaviors
		["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
			dropArea.dom.dropAreaEl.addEventListener(
				eventName,
				preventDefaults,
				false
			);
			document.body.addEventListener(eventName, preventDefaults, false);
		});

		// Highlight drop area when item is dragged over it
		["dragenter", "dragover"].forEach((eventName) => {
			dropArea.dom.dropAreaEl.addEventListener(
				eventName,
				highlight,
				false
			);
		});
		["dragleave", "drop"].forEach((eventName) => {
			dropArea.dom.dropAreaEl.addEventListener(
				eventName,
				unhighlight,
				false
			);
		});

		// Handle dropped files
		dropArea.dom.dropAreaEl.addEventListener("drop", handleDrop, false);
		dropArea.dom.dropAreaEl.addEventListener(
			"click",
			() => {
				// @ts-ignore
				dropArea.dom.jsfileElem.click();
			},
			false
		);

		//@ts-ignore
		window.handleFiles = handleFiles;
	},
	valid: (files: Array<any>): Array<any> => {
		const allowed = [
			"7zip",
			"gif",
			"zip",
			"rar",
			"mp3",
			"wav",
			"wma",
			"aiff",
			"flac",
			"jpg",
			"jpeg",
			"png",
		];
		return [...files].filter((file) => {
			const arr = file.name.split(".");
			const type = arr[arr.length - 1];
			return allowed.includes(type);
		});
	},
};
document.addEventListener("DOMContentLoaded", () => {
	if (document.getElementById("jsDropArea")) {
		dropArea.init();
		customMix.init();
		//@ts-ignore
		window.dropArea = dropArea;
		//@ts-ignore
		window.customMix = customMix;
	}
});
